import { render, staticRenderFns } from "./AppIdConfig.vue?vue&type=template&id=21793847&scoped=true"
import script from "./AppIdConfig.vue?vue&type=script&lang=js"
export * from "./AppIdConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21793847",
  null
  
)

export default component.exports